import { render, staticRenderFns } from "./detailReport.vue?vue&type=template&id=12ff511e&scoped=true"
import script from "./detailReport.vue?vue&type=script&lang=js"
export * from "./detailReport.vue?vue&type=script&lang=js"
import style0 from "./detailReport.vue?vue&type=style&index=0&id=12ff511e&prod&lang=css"
import style1 from "./detailReport.vue?vue&type=style&index=1&id=12ff511e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff511e",
  null
  
)

export default component.exports